import axios from 'axios';
import type { QueryParamsInterface } from '../../../types/Shared';
import { baseUrl, HttpMethods } from '../../base';
import type { GetOrgTitlesServiceRes, IPostNewTitleService, PatchTitleService } from './types';

const orgTitleBasePath = `${baseUrl.TERMINAL}/user-management/titles`;

export async function postNewTitleRole({ data }: IPostNewTitleService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: orgTitleBasePath,
    data,
  });
  return res.data;
}

export async function getOrgTitles(params?: QueryParamsInterface) {
  const resp = await axios.request<GetOrgTitlesServiceRes>({
    method: HttpMethods.GET,
    url: orgTitleBasePath,
    params,
  });
  return resp.data;
}

export async function patchTitle({ titleId, data }: PatchTitleService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${orgTitleBasePath}/${titleId}`,
    data,
  });
  return res.data;
}
